<div class="custom-dialog">
  <div class="container d-justify-bw">
    <div class="custom-dialog__left">
      <div class="mat-dialog-title custom-dialog__title d-justify-bw">
        <div class="title">
          <h3 class="title-text">The uploaded file contains invalid values</h3>
        </div>
        <div class="close">
          <button mat-icon-button aria-label="Close dialog" (click)="close()">
            <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">close</mat-icon>
          </button>
        </div>
      </div>
      <mat-dialog-content class="custom-dialog__text" style="padding-top: 10px;">
        
        <!-- Template Errors Section -->
        <div *ngIf="hasTemplateErrors" class="error-section" style="background: none; border: none; padding: 0;">
          <h4 style="margin-bottom: 10px; font-weight: bold;">Template Error</h4>
          <ul style="margin-top: 8px; padding-left: 20px; margin-bottom: 20px;">
            <li *ngFor="let err of data.templateErrors" style="margin-bottom: 8px;">
              {{err}}
            </li>
          </ul>
        </div>

        <!-- Missing Mandatory Fields Section -->
        <div *ngIf="hasMissingFields" class="error-section" style="background: none; border: none; padding: 0;">
          <h4 style="margin-bottom: 10px; font-weight: bold;">Missing Mandatory Fields</h4>
          <ul style="margin-top: 8px; padding-left: 20px; margin-bottom: 20px;">
            <li *ngFor="let err of data.missingFields" style="margin-bottom: 8px;">
              <strong>Row {{err.row}}:</strong> {{err.fields.join(' is missing, ')}} is missing
            </li>
          </ul>
        </div>

        <!-- Invalid Master Data Section -->
        <div *ngIf="hasInvalidMasterData" class="error-section" style="background: none; border: none; padding: 0; margin-bottom: 20px;">
          <p style="margin-bottom: 16px;">The following values do not exist in your company:</p>

          <div *ngIf="data.invalidMasterData.branches.length > 0" style="margin-bottom: 16px;">
            <strong style="display: block; margin-bottom: 8px;">Branches</strong>
            <ul style="margin-top: 0; padding-left: 20px;">
              <li *ngFor="let branch of data.invalidMasterData.branches">{{branch}}</li>
            </ul>
          </div>

          <div *ngIf="data.invalidMasterData.departments.length > 0" style="margin-bottom: 16px;">
            <strong style="display: block; margin-bottom: 8px;">Departments</strong>
            <ul style="margin-top: 0; padding-left: 20px;">
              <li *ngFor="let dept of data.invalidMasterData.departments">{{dept}}</li>
            </ul>
          </div>

          <div *ngIf="data.invalidMasterData.designations.length > 0" style="margin-bottom: 16px;">
            <strong style="display: block; margin-bottom: 8px;">Designations</strong>
            <ul style="margin-top: 0; padding-left: 20px;">
              <li *ngFor="let desig of data.invalidMasterData.designations">{{desig}}</li>
            </ul>
          </div>
        </div>

        <!-- In-file Duplicates Section -->
        <div *ngIf="hasDuplicateErrors" class="error-section" style="background: none; border: none; padding: 0;">
          <h4 style="margin-bottom: 10px; font-weight: bold;">Duplicates Found in Uploaded File</h4>
          <ul style="margin-top: 8px; padding-left: 20px; margin-bottom: 0;">
            <li *ngFor="let err of data.duplicateEmployeeCodes" style="margin-bottom: 8px;">
              <strong>Row {{err.row}}:</strong> Duplicate Employee Code found in uploaded file: {{err.code}}
            </li>
            <li *ngFor="let err of data.duplicateEmails" style="margin-bottom: 8px;">
              <strong>Row {{err.row}}:</strong> Duplicate Email Address found in uploaded file: {{err.email}}
            </li>
          </ul>
        </div>

      </mat-dialog-content>

      <mat-dialog-actions class="upload-action" style="justify-content: flex-end;">
        <button class="button--secondary-small" mat-button (click)="close()">Close</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
